<template>
  <div class="inform">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'通知管理'}]"></breadcrumb>
    <div class="inform-wrap">
      <div class="inform-contain">
        <public-top-nav>
          <el-button @click="gotoPublish()" type="primary">
            <font-awesome-icon :icon="['fas', 'pencil-alt']"/>
            <span style="margin-left:5px; font-size:14px;" >发布通知</span>
          </el-button>
        </public-top-nav>
        <div class="inform-table-wrap">
          <div class="inform-table">
            <table>
              <tr @click="gotoReadMsg(item.id)" v-for="item in informList" :key="item.id">
                <td class="inform-table_col1">
                  <div class="inform-table_top" v-if="item.top">置顶</div>
                  <div class="inform-table_urgent" v-if="item.urgent">加急</div>
                  {{(item.typeName?"【"+item.typeName+"】":"")+item.name}}
                </td>
                <td class="inform-table_col2">
                  <div class="inform-table_attachment" v-if="item.attachment">
                    <font-awesome-icon
                      style="color:#F0722B; margin-right:5px;"
                      :icon="['fas', 'download']"
                    />
                    {{item.attachment.split(",").length + "个附件"}}
                  </div>
                  {{(item.updatTime||item.createTime)|timeFilter}}
                </td>
                <td class="inform-table_col3">
                  <font-awesome-icon
                    style="color:#9b9b9b; margin-right:5px; margin-left:10px"
                    :icon="['fas', 'eye']"
                  />
                  {{item.isReadNum||0}}/{{item.sum}}
                </td>
                <td class="inform-table_col4">
                  <div @click.stop="popConfirm(item.id)">
                    <font-awesome-icon
                      style="color:#D44052; margin-right:5px;"
                      :icon="['fas', 'minus-circle']"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination
            @current-change="changePage"
            :current-page="page"
            class="inform-pagination"
            background
            layout="prev, pager, next"
            :total="listSize"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/servies/axios";
import api from "@/servies/api";
import breadcrumb from "@/components/breadcrumb";
import publicTopNav from "@/components/publicTopNav";
export default {
  components: {
    breadcrumb,
    publicTopNav
  },
  data() {
    return {
      page: 1,
      informList: [],
      listSize: 0
    };
  },
  filters: {
    timeFilter(value) {
      return value.replace("T", " ");
    }
  },
  created() {
    this.getList();
  },
  methods: {
    changePage(v) {
      this.page = v;
      this.getList();
    },
    getList() {
      axios
        .get(api.manageList + `\\${this.page}\\10`)
        .then(res => {
          if (res.data.code === 0) {
            console.log("获取通知管理列表成功", res.data.result);
            this.informList = res.data.result.records;
            this.listSize = res.data.result.total;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          this.$message.error("网络错误，请稍后重试");
        });
    },
    popConfirm(id) {
      this.$confirm('删除后不可恢复，确认删除？', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.deleteInfo(id)
        }).catch(() => {
        });

    },
    deleteInfo(id) {
      axios.get(api.deleteById+`\\${id}`).then(res =>{
        if(res.data.code === 0){
          this.$message({
              message: '删除通知成功',
              type: 'success'
            })
          this.getList()
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(error => {
        this.$message.error("网络错误，请稍后重试");
      })

    },
    gotoPublish() {
      this.$router.push({ path: "/public/inform/publish" });
    },
    gotoReadMsg(id){
      this.$router.push({ path: `/public/inform/readmessage/${id}` });
    }
  }
};
</script>


<style lang="scss" scoped>
.inform {
  .inform-wrap {
    padding: 77px 30px 0px 30px;
    .inform-contain {
      background: #fff;
      .inform-table-wrap {
        padding: 30px;
        .inform-table {
          height: 470px;
          tr {
            height: 47px;
            cursor: pointer;
            td {
              div {
                display: inline-block;
              }
            }
            .inform-table_col1 {
              padding-left: 20px;
              .inform-table_urgent {
                font-size: 11px;
                color: #fff;
                background: #39b54a;
                width: 28px;
                height: 16px;
                border-radius: 2px;
                text-align: center;
                line-height: 16px;
              }
              .inform-table_top {
                margin-right: 11px;
                font-size: 8px;
                color: #fff;
                background: #f0722b;
                width: 28px;
                height: 16px;
                border-radius: 2px;
                text-align: center;
                line-height: 16px;
              }
              div {
                &:last-child {
                  margin-right: 10px;
                }
              }
            }
            .inform-table_col2 {
              width: 240px;
              text-align: right;
              padding-right: 10px;
              color: #9b9b9b;
              .inform-table_attachment {
                text-align: left;
                width: 77px;
                color: #4a4a4a;
                margin-right: 25px;
              }
            }
            .inform-table_col3 {
              width: 70px;
            }
            .inform-table_col4 {
              cursor: pointer;
              width: 32px;
              padding-right: 20px;
              text-align: right;
            }
          }
        }
        .inform-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
